import React from "react";
import DeviceDetailRouteCore from "../DeviceDetailRoutePage";
import { useLazyGetDealerRolesDeviceDetailQuery } from "../../../store/dealerRoles/devicesApi";

/**
 * Bayi (dealer) firma kullanıcıları için cihaz detay sayfası.
 * Ağır detay mantığı paylaşılan çekirdekte; bu kabuk bayi cihaz-detay
 * endpoint'ini (/api/devices/dealerRoles/getDeviceDetail) geçirir — böylece
 * sayfa yenilemede de (Git state'i olmadan) cihaz yüklenir.
 */
export default function DealerDeviceDetailRoutePage() {
  return (
    <DeviceDetailRouteCore
      useDeviceDetailQuery={useLazyGetDealerRolesDeviceDetailQuery}
      isDealer={true}
    />
  );
}
